const createInstance = (complementaryProductsServiceClient, complementaryProductsAnchor, complementaryProductsComponent) => {

  const handleInitialPageLoad = async (parentProductCode) => {
    try {
      const complementaryProducts = await fetchComplementaryProducts(complementaryProductsServiceClient, parentProductCode);

      if (complementaryProducts.length > 0) {
        complementaryProductsComponent.renderSuccess(complementaryProducts, parentProductCode);
        complementaryProductsAnchor.enable();
      } else {
        complementaryProductsAnchor.disable();
        complementaryProductsComponent.destroy();
      }
    } catch (error) {
      complementaryProductsAnchor.disable();
      complementaryProductsComponent.destroy();
    }
  };

  async function fetchComplementaryProducts(complementaryProductsServiceClient, parentProductCode) {
    const response = await complementaryProductsServiceClient.fetchComplementaryProducts(parentProductCode);

    return response.complementaryProducts || [];
  }

  return {
    handleInitialPageLoad
  };
};

export default createInstance;
